import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { findWhere } from 'underscore';

Snappy.Component.RelatedContent = class RelatedContent extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-related-content';
	}

	constructor(element) {
		super(element);
	}

	render() {
		this.setVars();
		this.trackCarousels();
		this.addEventListeners();
		this.activateDefaultTab();
	}

	setVars() {
		this.activeClass = 'active';
		this.$singleMenuTabs = this.$element.find('.content-tabs-menu__item');
		this.$singleMenuTabButtons = this.$element.find('.content-tabs-menu__button');
		this.$contentTabs = this.$element.find('.tabs-container__single-tab');
	}

	trackCarousels() {
		this.carousels = Array.from(this.$contentTabs).map((tab, index) => {
			const $component = $(tab).find('.fa-carousel');

			return {
				initiated: false,
				index,
				$carousel: $component,
				component: $component[0].component
			};
		});
	}

	addEventListeners() {
		this.$singleMenuTabButtons.on('click', this.onMenuTabClick.bind(this));
	}

	activateDefaultTab() {
		const defaultIndex = 0;

		this.setActiveTabMenuItem($(this.$singleMenuTabButtons[defaultIndex]));
		this.activateTab(defaultIndex);
		this.activateCarousel(defaultIndex);
	}

	onMenuTabClick(event) {
		const $el = $(event.currentTarget);
		const tabIndex = $el.data('tab');

		this.setActiveTabMenuItem($el);
		this.activateTab(tabIndex);
		this.activateCarousel(tabIndex);
	}

	setActiveTabMenuItem($el) {
		this.$singleMenuTabs.removeClass(this.activeClass);
		$el.parent().addClass(this.activeClass);
	}

	activateTab(index) {
		const $activeTab = this.$contentTabs.filter(`[data-tab="${index}"]`);

		this.$contentTabs.removeClass(this.activeClass);
		$activeTab.addClass(this.activeClass);
	}

	activateCarousel(index) {
		const carousel = findWhere(this.carousels, { index });

		if (!carousel.initiated) {
			carousel.component.$carousel.slick(carousel.component.options);
			carousel.initiated = true;
		}
	}
};



// WEBPACK FOOTER //
// ./components/relatedContent/scripts/relatedContent.js